import { Column } from '@devexpress/dx-react-grid'
import { Theme } from '@mui/material'

export const COLUMNS: Column[] = [
  {
    name: 'size',
    title: 'Size',
  },
  {
    name: 'isClimate',
    title: 'Climate',
  },
  {
    name: 'isCovered',
    title: 'Covered',
  },
  {
    name: 'unitNumber',
    title: 'Unit Number',
  },
  {
    name: 'isAvailable',
    title: 'Available',
  },
  {
    name: 'statusLabel',
    title: 'Status',
  },
]

export const TitleProps = {
  sx: {
    background: (theme: Theme) => theme.palette.grey[400],
    py: 1,
  },
}

export const DialogActionProps = {
  sx: {
    borderTop: (theme: Theme) => `1px solid ${theme.palette.grey[400]}`,
  },
}

export const ContentProps = {
  sx: {
    borderTop: (theme: Theme) => `1px solid ${theme.palette.grey[400]}`,
    padding: '16px !important',
  },
}

export const ConfirmationButtonProps = {
  variant: 'contained' as 'text' | 'contained' | 'outlined' | undefined,
}
